<template>
     <back-layout title="Ofertas de Emprego">
        <template #header>
            <div class="flex justify-between px-4 flex-col sm:flex-row">
                <h2 class="font-semibold text-2xl lg:text-4xl text-gray-300 leading-tight mb-4 md:mb-0">Ofertas de Emprego</h2>
                <Link :href="route('create.job')" class="border border-primary-900 text-primary-900 uppercase text-sm py-2 px-4 font-bold rounded-full flex items-center hover:bg-white hover:bg-opacity-50 transition"><icon name="plus-circle" class="w-5 h-5 mr-2" /> Criar Oferta</Link>
            </div>
        </template>

        <!-- SEARCH BOX GOES HERE -->

        <div class="container mx-auto px-4">
            <div class="lg:flex lg:space-x-4">
                <div class="bg-white overflow-hidden shadow rounded-lg p-4 h-full relative top-0 lg:top-8 lg:w-[35vw] mb-4">
                    <h3 class="font-bold">Categorias</h3>
                    <div v-if="categories.length" class="my-4 grid grid-cols-2 gap-2">
                        <div v-for="category in categories" :value="category.id" class="h-full">
                            <div class="flex bg-white border text-sm rounded shadow py-1 px-2 items-center space-x-2 text-xs h-full justify-between">{{ category.name }} <button @click.prevent="removeCat(category)"><icon name="close" class="w-4 h-4 text-amber-600 justify-self-end" /></button></div>
                        </div>
                    </div>

                    <jet-button @click.prevent="showCatModal = true" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-violet-500 !p-0 text-left text-xs">Adicionar categoria</jet-button>

                    <!-- Modal -->
                    <jet-dialog-modal :show="showCatModal" @close="showCatModal = false">
                        <template #title>
                            Adicionar Categoria
                        </template>

                        <template #content>
                            <label class="form-label text-sm font-bold">Nome</label>
                            <jet-input type="text" v-model="cat.name" class="w-full" />

                            <div class="w-full mt-4">
                                <img :src="showImage" :alt="cat.name" class="w-full h-40 object-cover mb-4 mx-auto" v-if="showImage">
                                <!-- Image -->
                                <file-input v-model="cat.image" :error="cat.errors.image" class="w-full" type="file" accept="image/*" label="Imagem" @change="getImage" />
                            </div>

                        </template>

                        <template #footer>
                            <jet-secondary-button @click="showCatModal = false">
                                Cancelar
                            </jet-secondary-button>

                            <jet-button @click.prevent="createCategory" class="ml-2">Adicionar</jet-button>
                        </template>
                    </jet-dialog-modal>
                </div>

                <div class="w-full">
                    <div v-if="jobs.length">
                    <div class="px-4 my-2 flex items-center uppercase text-xs font-bold justify-between">
                        <p class="flex-1">Título</p>
                        <p class="flex-1 hidden md:block">Localidade</p>
                        <p class="flex-1">Estado</p>
                        <p class="flex-1">Ações</p>
                    </div>
                    <div v-for="job in jobs" class="bg-white overflow-hidden shadow rounded-lg p-4 my-2 flex items-center self-start space-x-2">
                        <Link :href="route('edit.job', job.slug)" class="flex-1 font-bold text-xs md:text-sm">{{ job.title }}</Link>
                        <p class="flex-1 hidden md:block text-xs md:text-sm">{{ job.freguesia }} - {{ job.distrito }}</p>
                        <p class="flex-1 uppercase font-bold text-xs" v-html="job.is_published == 1 ? `<span class='bg-violet-500 text-white py-1 px-2 rounded-full'>Público</span>` : `<span class='bg-gray-300 text-white py-1 px-2 rounded-full'>Rascunho</span>`"></p>
                        <div class="flex-1 flex flex-col space-y-2">
                            <jet-button @click.prevent="editJob(job.slug)" class="flex justify-center py-1 px-2 text-xs rounded-full border border-gray-400 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-gray-400 focus:border-gray-400 focus:ring-transparent active:shadow-0 focus:shadow-0 text-gray-400 mr-2"><icon name="edit" class="w-3 h-3" /> Editar</jet-button>

                            <jet-button @click.prevent="removeJob(job.slug)" class="flex justify-center py-1 px-2 text-xs rounded-full border border-amber-600 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-amber-600 focus:border-amber-600 focus:ring-transparent active:shadow-0 focus:shadow-0 text-amber-600 mr-2"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
                        </div>
                    </div>
                    </div>
                    <div v-else class="text-center pt-20">
                        <em class="text-gray-400">Sem Ofertas</em>
                    </div>
                    <!-- <table class="table-auto bg-white shadow p-4 rounded-lg w-full">
                        <thead class="text-left">
                            <th class="p-4">Título</th>
                            <th class="hidden lg:block p-4">Localidade</th>
                            <th class="p-4">Estado</th>
                            <th class="p-4">Ações</th>
                        </thead>
                        <tbody>
                            <tr v-for="job in jobs" class="border-t-8 border-gray-100">
                                <td><Link :href="route('edit.job', job.id)" class="font-bold p-4">{{ job.title }}</Link></td>
                                <td class="hidden lg:block">{{ job.freguesia }} - {{ job.distrito }}</td>
                                <td><span class="uppercase font-bold text-xs" v-html="job.is_published ? `<span class='bg-cyan-500 text-white p-1 rounded'>Público</span>` : `<span class='bg-gray-300 text-white p-1 rounded'>Rascunho</span>`"></span></td>
                                <td>
                                    <div class="flex flex-col space-y-2">
                                        <jet-button @click.prevent="editJob(job)" class="py-1 px-2 text-xs rounded border border-gray-400 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-gray-400 focus:border-gray-400 focus:ring-transparent active:shadow-0 focus:shadow-0 text-gray-400 mr-2"><icon name="edit" class="w-3 h-3" /> Editar</jet-button>

                                        <jet-button @click.prevent="removeJob(job)" class="py-1 px-2 text-xs rounded border border-amber-600 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-amber-600 focus:border-amber-600 focus:ring-transparent active:shadow-0 focus:shadow-0 text-amber-600 mr-2"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
                                    </div>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table> -->
                </div>
            </div>
        </div>
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import Icon from '@/Jetstream/Icon'
    import JetInput from '@/Jetstream/Input.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import FileInput from '@/Components/FileInput.vue'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
            JetButton,
            Icon,
            JetInput,
            JetSecondaryButton,
            JetDialogModal,
            FileInput
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            jobs: Array,
            categories: Array
        },
        data() {
            return {
                imagePreview: null,
                showCatModal: false,
                cat: this.$inertia.form({
                    name: '',
                    image: null
                }),
            }
        },
        computed: {
            showImage() {
                if(this.imagePreview != null) {
                    return this.imagePreview
                } else if(this.cat.image) {
                    return '/storage/categories/images/' + this.cat.image
                } else {
                    return false
                }
            }
        },
        methods: {
            dateFormated(jobDate) {
                let date = new Date(jobDate)
                return date.toLocaleDateString()
            },
            editJob(job) {
                this.$inertia.get(route('edit.job', job));
            },
            removeJob(job) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.job', job));
                }
            },
            createCategory() {
                this.cat.post(route('store.category'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.cat.reset()
                        this.showCatModal = false
                        this.imagePreview = null
                    },
                    onError: () => {
                    }
                })
            },
            removeCat(cat) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.category', cat));
                }
            },
            getImage(event) {
              this.cat.image = event.target.files[0]
              this.imagePreview = URL.createObjectURL(this.cat.image)
            }
        },
    })
</script>